"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ActionButton_1 = __importDefault(require("./buttons/ActionButton"));
var Button_1 = __importDefault(require("./buttons/Button"));
var Icon_1 = __importDefault(require("./Icon"));
var Loader_1 = __importDefault(require("./Loader"));
var resizeImage = function (image, maxWidth, maxHeight) {
    return new Promise(function (resolve, _reject) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var width = image.width;
        var height = image.height;
        var newWidth = width;
        var newHeight = height;
        if (width > height) {
            if (width > maxWidth) {
                newHeight *= maxWidth / width;
                newWidth = maxWidth;
            }
        }
        else {
            if (height > maxHeight) {
                newWidth *= maxHeight / height;
                newHeight = maxHeight;
            }
        }
        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0, newWidth, newHeight);
        resolve(canvas.toDataURL('image/png'));
    });
};
var cropperToImage = function (cropper) { return __awaiter(void 0, void 0, void 0, function () {
    var type, canvas, resizedDataUrl, binary, length, byteArray, idx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                type = "image/png";
                canvas = cropper.getCroppedCanvas({
                    imageSmoothingEnabled: true,
                    imageSmoothingQuality: "high"
                });
                return [4 /*yield*/, resizeImage(canvas, 2880, 2880)];
            case 1:
                resizedDataUrl = _a.sent();
                binary = window.atob(resizedDataUrl.split(",")[1]);
                length = binary.length;
                byteArray = new Uint8Array(length);
                for (idx = 0; idx < length; idx += 1) {
                    byteArray[idx] = binary.charCodeAt(idx);
                }
                return [2 /*return*/, new Blob([byteArray], { type: type })];
        }
    });
}); };
var ImageEditor = /** @class */ (function (_super) {
    __extends(ImageEditor, _super);
    function ImageEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.cropper = null;
        _this.buttonSaveRef = react_1.default.createRef();
        _this.componentIsMounted = false;
        _this.imageRef = react_1.default.createRef();
        _this.isSaveClicked = false;
        _this.editSaveText = function () { return __awaiter(_this, void 0, void 0, function () {
            var onEdit, saveButtonRef, croppedImageBlob, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onEdit = this.props.onEdit;
                        saveButtonRef = this.buttonSaveRef.current;
                        if (!saveButtonRef) return [3 /*break*/, 4];
                        saveButtonRef.innerText = "Saving...";
                        saveButtonRef.disabled = true;
                        this.isSaveClicked = true;
                        if (!(onEdit && this.cropper)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, cropperToImage(this.cropper)];
                    case 2:
                        croppedImageBlob = _a.sent();
                        onEdit(croppedImageBlob, true);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        saveButtonRef.innerText = "Save";
                        saveButtonRef.disabled = false;
                        this.isSaveClicked = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleRotateLeft = function () {
            if (_this.cropper) {
                _this.cropper.rotate(-45);
            }
        };
        _this.handleRotateRight = function () {
            if (_this.cropper) {
                _this.cropper.rotate(45);
            }
        };
        _this.handleZoomIn = function () {
            if (_this.cropper) {
                _this.cropper.zoom(0.2);
            }
        };
        _this.handleZoomOut = function () {
            if (_this.cropper) {
                _this.cropper.zoom(-0.2);
            }
        };
        _this.handleSave = function (closeModal) {
            if (closeModal === void 0) { closeModal = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var onEdit, croppedImageBlob;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            onEdit = this.props.onEdit;
                            if (!(onEdit && this.cropper)) return [3 /*break*/, 2];
                            return [4 /*yield*/, cropperToImage(this.cropper)];
                        case 1:
                            croppedImageBlob = _a.sent();
                            onEdit(croppedImageBlob, closeModal);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        _this.state = {
            isLoading: true
        };
        return _this;
    }
    ImageEditor.prototype.componentDidMount = function () {
        var _this = this;
        this.componentIsMounted = true;
        Promise.resolve().then(function () { return __importStar(require("./Cropper")); }).then(function (module) {
            var image = _this.imageRef.current;
            if (_this.componentIsMounted && image) {
                var aspectRatio = _this.props.aspectRatio;
                var ImageCropper = module.default;
                _this.cropper = new ImageCropper(image, {
                    aspectRatio: aspectRatio,
                    dragMode: "move",
                    autoCropArea: 1,
                    responsive: true,
                    ready: function () {
                        _this.setState({ isLoading: false });
                    }
                });
            }
        }).catch(function () {
            // this catch is largely here because in the case that you're not in an
            // environment that supports dynamic import (like jest when you're not
            // compiling vendored code) it will spam the console otherwise
        });
    };
    ImageEditor.prototype.componentWillUnmount = function () {
        this.componentIsMounted = false;
        var clickOutsideCancel = this.props.clickOutsideCancel;
        if (!clickOutsideCancel || this.isSaveClicked) {
            this.handleSave();
        }
        if (this.cropper) {
            this.cropper.destroy();
        }
    };
    ImageEditor.prototype.render = function () {
        var _a = this.props, image = _a.image, onFailure = _a.onFailure;
        var isLoading = this.state.isLoading;
        return (react_1.default.createElement("div", { className: "chq-ied" },
            react_1.default.createElement("div", { className: "chq-ied--ctrl" },
                react_1.default.createElement(ActionButton_1.default, { "aria-label": "Rotate left", icon: "arrow-return-left", onClick: this.handleRotateLeft }),
                react_1.default.createElement(ActionButton_1.default, { "aria-label": "Rotate right", icon: "arrow-return-right", onClick: this.handleRotateRight }),
                react_1.default.createElement(ActionButton_1.default, { "aria-label": "Zoom in", icon: "ios-plus-outline", onClick: this.handleZoomIn }),
                react_1.default.createElement(ActionButton_1.default, { "aria-label": "Zoom out", icon: "ios-minus-outline", onClick: this.handleZoomOut }),
                react_1.default.createElement(Button_1.default, { ref: this.buttonSaveRef, primary: true, onClick: this.editSaveText, disabled: isLoading },
                    react_1.default.createElement(Icon_1.default, { icon: "ios-camera-outline" }),
                    " Save")),
            react_1.default.createElement("div", { className: "chq-ied--img" },
                isLoading
                    && (react_1.default.createElement(Loader_1.default, { loading: true })),
                react_1.default.createElement("img", { ref: this.imageRef, src: image || undefined, alt: "Preview", onError: onFailure }))));
    };
    return ImageEditor;
}(react_1.default.Component));
exports.default = ImageEditor;
